import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>Copyright (c) 2006 C & V Corporation All Rights Reserved</p>
    </footer>
  );
};

export default Footer;
